/* ============================================================
   Vesper — Judge.me reviews carousel navigation
   Judge.me renders `.jdgm-rev-widg__reviews` as a horizontal
   scroll row with no visible way to scroll it. This script
   injects a small prev/next control row above the cards and
   wires it up to scroll the row by one card width at a time.
   Vanilla JS, no dependencies. Idempotent: safe to run again if
   the widget re-renders (e.g. after a review is submitted).
   ============================================================ */
(function () {
  'use strict';

  var CONTAINER_SELECTOR = '.jdgm-rev-widg__reviews';
  var CARD_SELECTOR = '.jdgm-rev';
  var READY_ATTR = 'data-vesper-nav-ready';
  var FADE_HIDE_CLASS = 'vesper-rev-fade-hide';

  function chevronSvg(direction) {
    var d = direction === 'left' ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6';
    return (
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="2" stroke-linecap="round" ' +
      'stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"></path></svg>'
    );
  }

  function stepDistance(container) {
    var card = container.querySelector(CARD_SELECTOR);
    if (!card) return Math.round(container.clientWidth * 0.9);
    var cardWidth = card.getBoundingClientRect().width;
    var style = window.getComputedStyle(container);
    var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
    return Math.round(cardWidth + gap);
  }

  function attachNav(container) {
    if (!container || container.getAttribute(READY_ATTR) === 'true') return;
    container.setAttribute(READY_ATTR, 'true');

    var nav = document.createElement('div');
    nav.className = 'vesper-rev-nav';
    nav.setAttribute('role', 'group');
    nav.setAttribute('aria-label', 'Review navigation');

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.setAttribute('aria-label', 'Previous reviews');
    prevBtn.innerHTML = chevronSvg('left');

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.setAttribute('aria-label', 'Next reviews');
    nextBtn.innerHTML = chevronSvg('right');

    nav.appendChild(prevBtn);
    nav.appendChild(nextBtn);

    if (container.parentNode) {
      container.parentNode.insertBefore(nav, container);
    }

    var fadeParent = container.parentElement;

    function updateState() {
      var maxScroll = container.scrollWidth - container.clientWidth;
      var hasOverflow = maxScroll > 1;

      nav.style.display = hasOverflow ? '' : 'none';

      if (!hasOverflow) {
        if (fadeParent) fadeParent.classList.add(FADE_HIDE_CLASS);
        return;
      }

      var atStart = container.scrollLeft <= 1;
      var atEnd = container.scrollLeft >= maxScroll - 1;

      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;

      if (fadeParent) fadeParent.classList.toggle(FADE_HIDE_CLASS, atEnd);
    }

    prevBtn.addEventListener('click', function () {
      container.scrollBy({ left: -stepDistance(container), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      container.scrollBy({ left: stepDistance(container), behavior: 'smooth' });
    });

    container.addEventListener('scroll', updateState, { passive: true });
    window.addEventListener('resize', updateState);

    updateState();
    // Judge.me can finish laying out cards/images slightly after the
    // container first appears, which changes scrollWidth — recheck.
    setTimeout(updateState, 300);
    setTimeout(updateState, 1200);
  }

  function scan() {
    var containers = document.querySelectorAll(CONTAINER_SELECTOR);
    for (var i = 0; i < containers.length; i++) {
      attachNav(containers[i]);
    }
  }

  var scanScheduled = false;
  function scheduleScan() {
    if (scanScheduled) return;
    scanScheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      scanScheduled = false;
      scan();
    });
  }

  function init() {
    scan();

    // Judge.me can mount/remount the widget asynchronously (lazy load,
    // AJAX cart, after a review submission). Keep watching so the nav
    // gets re-attached to any new container; the READY_ATTR guard on
    // each container makes this idempotent.
    var observer = new MutationObserver(scheduleScan);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
